
import { useEffect } from "react";

export function useDocumentTitle(title: string) {
  useEffect(() => {
    // Save the original title
    const originalTitle = document.title;
    
    // Set the new title
    document.title = `${title} | Dashboard`;
    
    // Reset the title when the component unmounts
    return () => {
      document.title = originalTitle;
    };
  }, [title]);
}
